import { Box } from "@mui/material";
import React, { useEffect } from "react";
import useObservedExpression from "../../Hooks/useObservedExpression";
import useObservedText from "../../Hooks/useObservedText";
import { WebViewModel } from "../../Models/WebViewModel";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

const WebViewComponent: React.FC<IComponentProps<WebViewModel>> = ({ component, context }) => {
  const componentLayoutSx = getComponentLayout(component);

  const [visible] = useObservedExpression<boolean>(component.Visible, context, "WebViewComponent");
  const url = useObservedText(component.UrlTemplate, context, "WebViewComponent");

  if (!url || visible === false) {
    return null;
  }

  return (
    <Box sx={{ ...componentLayoutSx }}>
      <iframe
        src={url}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          backgroundColor: "#c0c0c0",
        }}
        title="Web View"
      />
    </Box>
  );
};

export default WebViewComponent;
